const App = window.App;

const routeNavigateToIndex = () => {
    App.router.navigate(App.router.getUrl(null), {trigger: true});
};

export default routeNavigateToIndex;